import React from 'react';

const Projects = () => {
  return (
    <section style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>My Projects</h2>
      <p>Here’s where I’ll showcase my work.</p>
    </section>
  );
};

export default Projects;
